import { apiRequest } from "@/api/client";
import type {
  CreateIntegrationTokenRequest,
  CreateIntegrationTokenResponse,
  IntegrationToken,
} from "@/types/api";

/** Lista os tokens de integração (somente admin). */
export function listIntegrationTokens(): Promise<IntegrationToken[]> {
  return apiRequest<IntegrationToken[]>("/integration-tokens");
}

/** Cria um token; a resposta traz o segredo em claro uma única vez (201). */
export function createIntegrationToken(
  body: CreateIntegrationTokenRequest,
): Promise<CreateIntegrationTokenResponse> {
  return apiRequest<CreateIntegrationTokenResponse>("/integration-tokens", {
    method: "POST",
    body,
  });
}

/** Revoga um token ativo. */
export function revokeIntegrationToken(id: number): Promise<void> {
  return apiRequest<void>(`/integration-tokens/${id}`, {
    method: "DELETE",
  });
}
